import { useCallback, useEffect, useRef } from 'react';

import * as history from '@shared/router/location';
import * as uri from '@shared/router/uri';

export function useNavigationEvent(): (href: string) => void {
	return useCallback((href: string) => {
		if (!uri.isLocalPathOrUrl(href)) {
			window.open(href, '_blank', 'noreferrer');
			return;
		}

		if (!href || href.startsWith('#') || history.isCurrent(href)) {
			return;
		}

		history.push(href);
	}, []);
}

export function useNavigationBlocker(
	blocker: history.Blocker,
	when: boolean
): void {
	const latestBlocker = useRef<history.Blocker>(blocker);

	latestBlocker.current = blocker;

	useEffect(() => {
		if (!when) {
			return;
		}

		const handleBeforeUnload = (event: BeforeUnloadEvent) => {
			event.preventDefault();
		};

		const unblock = history.block((path, proceed) =>
			latestBlocker.current(path, proceed)
		);

		window.addEventListener('beforeunload', handleBeforeUnload);

		return () => {
			unblock();
			window.removeEventListener('beforeunload', handleBeforeUnload);
		};
	}, [when]);
}
